module.exports = require("github:jspm/nodelibs-fs@0.1.2/index");